import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { IStopInstanceRequest, IStopInstanceResponse, ITaskRequest, ITaskResponse } from "./api-nintex-interface";

const API_URL = `https://eu.nintex.io`;

export const apiNintexSlice = createApi({
    reducerPath: 'api-nintex',
    baseQuery:  retry(fetchBaseQuery({
        baseUrl: API_URL
    })),
    endpoints: (builder) => ({
        getTasks: builder.query<ITaskResponse, ITaskRequest>({
            query: (args) => {
                const { assignee, accessToken } = args;

                const headers = new Headers();
                headers.set('Content-Type', `application/json`);
                headers.set('Authorization', `Bearer ${accessToken}`);

                return {
                    url: `/workflows/v2/tasks?assignee=${assignee}`,
                    method: 'GET',
                    headers
                }
            }
        }),

        stopInstance: builder.query<IStopInstanceResponse, IStopInstanceRequest>({
            query: (args) => {
                const { instanceId, reason, accessToken } = args;

                const headers = new Headers();
                headers.set('Content-Type', `application/json`);
                headers.set('Authorization', `Bearer ${accessToken}`);

                const body = {
                    reason
                }

                return {
                    url: `/workflows/v1/instances/${instanceId}/terminate`,
                    method: 'POST',
                    headers,
                    body
                }
            }
        }),
    })
});

export const {
    useLazyGetTasksQuery,
    useLazyStopInstanceQuery
} = apiNintexSlice;